// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".render-percentage[data-v-4dada9a2] {\n  text-align: right;\n}", "",{"version":3,"sources":["webpack://assets/ui/render/render-percentage-column-value.vue","webpack://render-percentage-column-value.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF","sourcesContent":["\n.render-percentage {\n  text-align: right;\n}\n",".render-percentage {\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
